import _ from "lodash"
import { IndorImages } from "../../../features"
import { HIDDEN_MAP_MENU_ITEMS } from "./defaultMenuPatterns"

export const typesRequiringPathId = ['roadDiagnosticsSegments', 'roadMeasureResults']
export const menuSectionsForEmptyCheck = ['mapMenu', 'data', 'analyticsMenu', 'integration']

const unknownObjectTypeImageIndex = "6137"
const unknownObjectTypeTitle = "???"

export function createMapMenuItem(objectType: any, menuShow: any, excludedFromMapHiddenItemsList: string[]) {
    let { ImageIndex, Caption, UrlUrl, url: objectTypeUrl, mapLayer, Types, hidden } = objectType ?? {}
    const imageIndex = ImageIndex ? ImageIndex.toString().padStart(4, "0") : unknownObjectTypeImageIndex
    const title = Caption ?? unknownObjectTypeTitle
    let hasConditionsToShow = false
    let mapMenuItem: any = {
        title,
        imageIndex,
        mapLayer
    }
    if (mapLayer && (UrlUrl || objectTypeUrl)) {
        hasConditionsToShow = true
        const objectTypeName = UrlUrl ?? objectTypeUrl?.split('/')[1];
        const url = "/app/map/" + objectTypeName
        const menuShowObjectTypeName = `map.${objectTypeName}`
        if (menuShowObjectTypeName in menuShow) {
            hidden = !menuShow[menuShowObjectTypeName]
        }
        Object.assign(mapMenuItem, { url })
    }
    if (Types) {
        hasConditionsToShow = true
        Object.assign(mapMenuItem, { children: defineMapMenuItems(Types, menuShow, excludedFromMapHiddenItemsList) })
    }
    if (!hidden && hasConditionsToShow) {
        return mapMenuItem
    }
}

export function defineMapMenuItems(objectTypesStructure: any, menuShow: any, excludedFromMapHiddenItemsList: string[]) {
    if (!objectTypesStructure) return [];
    return objectTypesStructure?.map((objectType: any) => {
        const title = objectType?.Caption ?? unknownObjectTypeTitle
        const itemIsInHiddenList = HIDDEN_MAP_MENU_ITEMS.includes(title)
        const itemIsIgnoredInHiddenList = Array.isArray(excludedFromMapHiddenItemsList) && excludedFromMapHiddenItemsList.includes(title)
        if (itemIsInHiddenList && !itemIsIgnoredInHiddenList) return;
        return createMapMenuItem(objectType, menuShow, excludedFromMapHiddenItemsList)
    }).filter((item: any) => item)
}

export function defineTableOrAnalyticsMenuItems(objectTypesStructure: any, type: string, menuShow: any) {
    if (!objectTypesStructure) return [];
    return objectTypesStructure?.map((objectType: any) => {
        let { ImageIndex, Caption, UrlUrl, url: objectTypeUrl, Types, hidden } = objectType ?? {}
        const imageIndex = ImageIndex ? ImageIndex.toString().padStart(4, "0") : unknownObjectTypeImageIndex
        const title = Caption ?? unknownObjectTypeTitle
        let hasConditionsToShow = false
        let tableMenuItem = {
            title,
            imageIndex,
        }
        if (UrlUrl || objectTypeUrl) {
            hasConditionsToShow = true
            const objectTypeName = UrlUrl ?? objectTypeUrl?.split('/')[1]
            const url = `/app/${type}/` + objectTypeName
            const menuShowObjectTypeName = `${type}.${objectTypeName}`
            if (menuShowObjectTypeName in menuShow) {
                hidden = !menuShow[menuShowObjectTypeName]
            }
            Object.assign(tableMenuItem, { url })
        }
        if (type === "table") {
            Object.assign(tableMenuItem, { isPathRequired: true })
        }
        if (Types) {
            hasConditionsToShow = true
            Object.assign(tableMenuItem, { children: defineTableOrAnalyticsMenuItems(Types, type, menuShow) })
        }
        if (!hidden && hasConditionsToShow) {
            return tableMenuItem
        }
    }).filter((item: any) => item)
}

export function getClearedFromHiddenItemsMenuStructure(menuStructure: any, menuShow: any) {
    return menuStructure.map((menuItem: any) => {
        const { children, type, hidden } = menuItem ?? {}
        if (children?.length > 0) {
            menuItem = { ...menuItem, children: getClearedFromHiddenItemsMenuStructure(children, menuShow) }
        }
        if ((type in menuShow && menuShow[type] || !(type in menuShow)) && !hidden) {
            return menuItem
        }
    }).filter((item: any) => item)
}

export function defineAdditionalMenuItemsForMainMenu(additionalItems: any) {
    if (Array.isArray(additionalItems)) {
        const additionalMenuItems = additionalItems.map((item: any) => {
            let url = item?.url
            url = url.replace(':id', item?.id)
            url = url.replace(':objectType', item?.objectType)
            Object.assign(item, { url: '/app' + url, title: item?.title, hidden: !item?.mainMenuShow })
            return item
        })
        return additionalMenuItems
    }
}

export function defineAdditionalMenuItemsGroups(additionalMapMenuItems: any, additionalTableMenuItems: any, additionalItemsGroups: any) {
    let additionalMenuItemsGroups: any = []
    if (Array.isArray(additionalItemsGroups)) {
        let additionalMenuItemsIds: any = []
        if (Array.isArray(additionalMapMenuItems)) {
            const mapMenuItemsIds = additionalMapMenuItems.map((item: any) => item?.id)
            additionalMenuItemsIds = [...mapMenuItemsIds]
        }
        if (Array.isArray(additionalTableMenuItems)) {
            const tableMenuItemsIds = additionalTableMenuItems.map((item: any) => item?.id)
            additionalMenuItemsIds = [...additionalMenuItemsIds, ...tableMenuItemsIds]
        }
        const uniqueAdditionalMenuItemsIdsSet = new Set(additionalMenuItemsIds)
        const uniqueAdditionalMenuItemsIdsArray = Array.from(uniqueAdditionalMenuItemsIdsSet)
        additionalMenuItemsGroups = uniqueAdditionalMenuItemsIdsArray.map((id: any) => {
            const additionalItemsGroup = additionalItemsGroups.find((group: any) => group.id === id)
            if (additionalItemsGroup) {
                const { title: groupTitle, imageIndex: groupImageIndex } = additionalItemsGroup ?? {}
                let children: any = []
                if (Array.isArray(additionalMapMenuItems)) {
                    const additionalMapMenuItemsForGroup = additionalMapMenuItems.filter((item: any) => item.id === id).map((item: any) => {
                        let itemCopy = structuredClone(item)
                        itemCopy.imageIndex = IndorImages.Map;
                        itemCopy.title = `Карта`;
                        itemCopy.hidden = !item?.additionalGroupMenuShow
                        return itemCopy
                    })
                    if (additionalMapMenuItemsForGroup) {
                        children = [...children, ...additionalMapMenuItemsForGroup]
                    }
                }
                if (Array.isArray(additionalTableMenuItems)) {
                    const additionalTableMenuItemsForGroup = additionalTableMenuItems.filter((item: any) => item.id === id).map((item: any) => {
                        let itemCopy = structuredClone(item)
                        itemCopy.imageIndex = IndorImages.Table;
                        itemCopy.title = `Таблица`;
                        itemCopy.hidden = !item?.additionalGroupMenuShow
                        itemCopy.isPathRequired = true
                        return itemCopy
                    })
                    if (additionalTableMenuItemsForGroup) {
                        children = [...children, ...additionalTableMenuItemsForGroup]
                    }
                }
                const additionalMenuItemsGroup = {
                    title: groupTitle,
                    imageIndex: groupImageIndex,
                    children
                }
                return additionalMenuItemsGroup
            }
        })
    }
    return additionalMenuItemsGroups
}

function checkForChildrenOrUrl(menuSectionTypesToCheck: any, menuItem: any) {
    const { children, url } = menuItem ?? {}
    if (children?.length > 0) {
        menuItem = { ...menuItem, children: getClearedFromEmptySectionsMenuStructure(menuSectionTypesToCheck, children) }
        return menuItem
    } else if (url) {
        return menuItem
    }
}

export function getClearedFromEmptySectionsMenuStructure(menuSectionTypesToCheck: any, menuStructure: any) {
    return menuStructure.map((menuItem: any) => {
        const { type } = menuItem ?? {}
        if (type) {
            if (menuSectionTypesToCheck.includes(type)) {
                return checkForChildrenOrUrl(menuSectionTypesToCheck, menuItem)
            } else {
                return menuItem
            }
        } else {
            return checkForChildrenOrUrl(menuSectionTypesToCheck, menuItem)
        }
    }).filter((item: any) => item)
}

export function addDefaultAdditionalMenuItems(defaultAdditionalMenuItems: any, menuStructure: any) {
    if (Array.isArray(defaultAdditionalMenuItems)) {
        for (const menuItem of defaultAdditionalMenuItems) {
            let { menuSectionPath, positionAfter, item } = menuItem ?? {}
            const neededMenuPart = menuSectionPath.reduce((acc: any, pathPart: any) => {
                if (typeof pathPart === "string") {
                    return acc?.find((section: any) => section.title === pathPart)?.children
                }
                if (typeof pathPart === "number") {
                    return acc?.[pathPart - 1]?.children
                }
            }, menuStructure)
            if (typeof positionAfter === "number") {
                neededMenuPart?.splice(positionAfter, 0, item)
            }
            if (typeof positionAfter === "string") {
                let menuItemIndex = neededMenuPart?.findIndex((menuItem: any) => menuItem.title === positionAfter)
                neededMenuPart?.splice(menuItemIndex + 1, 0, item)
            }
        }
    }
}

export function findObjectTypeByCaption(objectTypesStructure: any, caption: string) {
    for (const obj of objectTypesStructure ?? []) {
        if (obj?.Caption === caption) return obj
        if (Array.isArray(obj?.Types)) {
            const found = findObjectTypeByCaption(obj.Types, caption)
            if (found) return found
        }
    }
}

export function defineMenuItemsMovements(objectTypesStructure: any, menuShow: any, movements: any[], excludedFromMapHiddenItemsList: string[]) {
    if (!Array.isArray(movements)) return []
    return movements.map((movement: any) => {
        const { Caption, renameTo, imageIndex, menuSectionPath = [], positionAfter } = movement ?? {}
        const objectType = findObjectTypeByCaption(objectTypesStructure, Caption)
        if (!objectType) return
        const item = createMapMenuItem(objectType, menuShow, excludedFromMapHiddenItemsList)
        if (!item) return
        if (renameTo) item.title = renameTo
        if (imageIndex) item.imageIndex = imageIndex
        return { menuSectionPath, positionAfter, item }
    }).filter((x: any) => x)
}